<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="{
            key: 'reporting.data-import.bulkImportTimeOff',
            params: { importer: (importer?.importerName | titlecase) },
        }"
        [back]="true"
    ></app-header>
    <ui-banner variant="success" class="margin-bottom-2" *ngIf="saved">
        {{ importer?.successMessage ?? 'reporting.data-import.processingFile' | translate }}
    </ui-banner>
    <div class="ui segment">
        <app-segment-header title="reporting.data-import.step1"></app-segment-header>
        <p class="no-margin">{{ 'reporting.data-import.selectWhichTimeOffType' | translate }}</p>
        <p class="no-margin">{{ 'reporting.data-import.pleaseEnsureYouAreAware' | translate }}</p>
        <p class="no-margin">{{ importer?.guide | translate }}</p>
        <p>{{ 'reporting.data-import.rowsWithMissingInfoWillBeSkipped' | translate }}</p>

        <div class="app-grid centered">
            <mat-form-field class="columns-3">
                <mat-label appRemoveAriaOwns>{{ 'reporting.data-import.timeOffType' | translate }}</mat-label>
                <mat-select
                    name="timeOffTypeField"
                    [placeholder]="'reporting.data-import.timeOffTypes' | translate"
                    (selectionChange)="onTimeOffTypeChange()"
                    [(ngModel)]="selectedTimeOffTypeId"
                    required
                >
                    <mat-option *ngFor="let timeOffType of timeOffTypes" [value]="timeOffType.id">{{
                        timeOffType.name
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
            <ui-button class="columns-2" type="primary" (click)="getImportTemplate()">
                {{ 'reporting.data-import.downloadBulkImportTemplate' | translate }}</ui-button
            >
        </div>
        <ui-banner variant="warning" class="no-margin" *ngIf="showPayrollMessage">
            {{ 'reporting.data-import.payrollTimeOffTypeMessage' | translate }}
        </ui-banner>
    </div>

    <div class="ui segment">
        <app-segment-header title="reporting.data-import.step2"></app-segment-header>
        <p>{{ 'reporting.data-import.uploadedCompletedSpreadsheetTohumi' | translate }}</p>
        <form class="ui form" #form="ngForm">
            <div class="app-grid centered">
                <mat-form-field class="file-upload columns-3">
                    <ui-mat-file-upload
                        (fileSelected)="importFileSelected($event)"
                        placeholder="{{ 'reporting.data-import.uploadASpreadsheet' | translate }}"
                        [allowedTypes]="['.csv']"
                        name="importer"
                    ></ui-mat-file-upload>
                    <ui-button type="outline">{{ 'reporting.data-import.browse' | translate }}</ui-button>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="ui segment">
        <app-segment-header title="reporting.data-import.step3"></app-segment-header>
        <p>{{ 'reporting.data-import.processingOfTheBulkImport' | translate }}</p>
        <p>{{ 'reporting.data-import.youWillReceiveEmailAlert' | translate }}</p>
    </div>

    <ui-button class="buttons" type="primary" [disabled]="!savedFileId" (click)="import()">{{
        'reporting.data-import.import' | translate
    }}</ui-button>
</div>
